export const defaultUserInfo = {
    name: "Jan Hrabal",
    email: "info@janhrabal.com",
    owner: true,
    currencies: {
        CZK: {
            isoCode: "CZK",
            symbol: "Kč",
            decimalDigits: 2,
            symbolPosition: "right",
            defaultCurrency: true,
        },
        EUR: {
            isoCode: "EUR",
            symbol: "€",
            decimalDigits: 2,
            symbolPosition: "left",
            defaultCurrency: null,
        },
        USD: {
            isoCode: "USD",
            symbol: "$",
            decimalDigits: 2,
            symbolPosition: "left",
            defaultCurrency: null,
        },
    },
    defaultCurrency: {
        isoCode: "CZK",
        symbol: "Kč",
        decimalDigits: 2,
        symbolPosition: "right",
        defaultCurrency: true,
    },
    defaultCurrencyCode: "CZK",
    decimalDelimiter: ",",
    thousandDelimiter: " ",
    dateFormat: "DD.MM.YYYY",
    timeFormat: "HH:mm",
    ampm: false,
    decimalDigits: 2,
    timesheetsSupport: true,
    employeesSupport: true,
    projectsSupport: true,
    counterpartiesSupport: true,
    pricelistsSupport: true,
    estimatesSupport: true,
    transactionsSupport: true,
    transactionsTaxSupport: true,
    documentsSupport: false,
    billingsSupport: false,
    hasFeatures: false,
    features: null,
    initialized: true,
    entitlements: {
        COUNTERPARTY_VIEW: {
            view: {},
            create: {},
            edit: {},
            delete: {},
            grant: {},
            counterpartyId: {
                all: true,
                values: [],
            },
        },
        FINANCIALS_VIEW: {},
        EMPLOYEES_VIEW: {
            employeeId: {
                all: true,
                values: [],
            },
        },
        TIMESHEETS_VIEW: {
            view: {
                employeeId: {
                    all: true,
                    values: [],
                },
            },
            create: {},
        },
        PROJECTS_VIEW: {
            projectId: {
                all: true,
            },
        },
        PRICELIST_VIEW: {},
        ESTIMATE_VIEW: {},
    },
    timesheetsSettings: {
        maxHours: 4,
        roundTo15: true,
        employeeRequired: true,
        projectRequired: true,
        descriptionRequired: false,
    },
    financesSettings: {
        name: "Jan Hrabal",
        idNumber: "75386771",
        taxIdNumber: "CZ8407194114",
        address: "Prostřední 2249\nZlín\n760 01",
    },
    transactionTypes: [
        {
            id: "uuid1",
            name: "Faktura",
            description: "",
            direction: "INCOME",

            hasCpty: true,
            counterpartyLabel: "Odběratel",
            hasSubjectInfo: true,
            subjectLabel: "Dodavatel",
            hasItems: true,
            hasTax: true,
            hasIdentificator: true,
            identificatorLabel: "Číslo faktury",
            hasDueDate: true,
            defaultDueDateDays: 20,
            hasPaymentInstructions: true,
            hasProjectReference: true,
            hasEmployeeReference: false,
            affectsTaxBasis: true,
            hasStatus: true,
            printable: true,
            currencyId: "uuid1234",
            paymentMethods: [
                {
                    id: "uuid2",
                    name: "Airbank CZK účet",
                    type: "Bankovní převod",
                    fields: [
                        { label: "Číslo účtu", source: "CUSTOM", value: "1135914015" },
                        { label: "Kód banky", source: "CUSTOM", value: "3030" },
                        {
                            label: "Variabilní symbol",
                            source: "TRANSACTION",
                            value: "idNumber",
                        },
                    ],
                    qrCode: [{}, {}],
                },
            ],
            printTemplateName: "Faktura",
            printTemplateCode: "invoice",
        },
        {
            id: "uuid2",
            name: "Náklad",
            direction: "EXPENDITURE",
            hasCpty: true,
            counterpartyLabel: "Dodavatel",
            hasIdentificator: true,
            identificatorLabel: "Číslo dokladu",
            hasTax: true,
            hasProjectReference: true,
            affectsTaxBasis: true,
        },
        {
            id: "uuid20",
            name: "Výplata zaměstnanci",
            direction: "EXPENDITURE",
            hasEmployeeReference: true,
            affectsTaxBasis: true,
        },
        { id: "uuid0", name: "Daň z příjmu", direction: "EXPENDITURE" },
        {
            id: "uuid3",
            name: "Sociální pojištění",
            direction: "EXPENDITURE",
        },
        {
            id: "uuid5",
            name: "Zdravotní pojištění",
            direction: "EXPENDITURE",
        },
    ],
    taxRates: [
        {
            id: "uuid1",
            name: "DPH 21%",
            description: "Základní sazba DPH",
            type: "PERCENTAGE",
            percentage: 21,
            default: true,
        },
        {
            id: "uuid2",
            name: "DPH 12%",
            description: "Snížená sazba DPH",
            type: "PERCENTAGE",
            percentage: 12,
            default: false,
        },
        {
            id: "uuid-2",
            name: "DPH 15%",
            description: "Snížená sazba DPH",
            type: "PERCENTAGE",
            percentage: 15,
            default: false,
            hidden: true,
        },
        {
            id: "uuid3",
            name: "DPH 0%",
            description: "Nulová sazba DPH",
            type: "PERCENTAGE",
            percentage: 0,
            default: false,
        },
    ],
};
